<template>
  <div v-if="fournisseurSupport" class="tableWithPerPageSelection">
    <div class="entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">
                {{ $t('detailFournisseurSupport.title', {nom: fournisseurSupport.nomCommercial })}}
              </h1>
              <app-breadcrumb :breadcrumb="breadcrumb"/>
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="buttons">
            <dropdownButton
              @click="$router.push({
                name: 'm.presse.fournisseur_support',
                params: { id: fournisseurSupport.id }
              })"
              :permission="permsFournisseurSupport.maj"
              :actions="actionSecondary"
              type="is-addOrEdit"
              class="mgr-2">
              {{ $t('detailFournisseurSupport.actions.edit') }}
            </dropdownButton>
            <b-dropdown class="button is-bottom-left">
              <div slot="trigger" class="right">
                <b-icon icon="call-split" type="is-default" class="mgt-5px"></b-icon>
                <b-icon icon="chevron-down" class="has-text-default"></b-icon>
              </div>
              <b-dropdown-item has-link>
                <router-link-blank
                  classComposant="noTextDecoration"
                  classMessage="is-block"
                  :to="{
                    name: 'l.presse.marche',
                    params: { fournisseurId: fournisseurSupport.id },
                  }"
                  :message="$t('detailFournisseurSupport.actions.marches')">
                </router-link-blank>
              </b-dropdown-item>
            </b-dropdown>
            <button class="button is-bottom-left has-text-left"
                    @click="checkPermissions(permsFournisseurSupport.lecture)
                      ? popUpEdition = true
                      : showPopUp()">
              <b-icon icon="file-download" type="is-default"></b-icon>
            </button>
            <piece-jointe-button
              class="mgr-2"
              :perm="permsFournisseurSupport.maj"
              autoSave>
            </piece-jointe-button>
          </div>
        </div>
      </div>
      <div class="tab">
        <ul>
          <li
            v-for="(tab, index) in tabs" :key="index"
            :class="{'is-active': activeTab === tab}"
            @click="activeTab = tab">
            {{ $t(`detailFournisseurSupport.tabs.${tab}`) }}
          </li>
        </ul>
      </div>
    </div>
    <component
      v-if="fournisseurSupport"
      :is="activeTab"
      :fournisseurSupport="fournisseurSupport"
      :afficherColonneAction="false"
      :afficherActionGroupe="false"
    ></component>
    <b-modal
      v-if="fournisseurSupport"
      v-model="openPopUpFusionTiers"
      :width="800"
      class="modal"
      has-modal-card>
      <popup-fusion-tiers
        :tiers="fournisseurSupport"
        :type="constantes.TIERS_TYPE_FOURNISSEUR"
        :sousTypes="[constantes.TIERS_SOUS_TYPE_FOURNISSEUR_SUPPORT]"
        tiersTypeForTrad="fournisseurSupport">
      </popup-fusion-tiers>
    </b-modal>
    <b-modal v-model="popUpEdition" has-modal-card class="modal">
      <pop-up-edition
        :error="errorEdition"
        :choiceEdition="listeChoiceEdition"
        :filtreDates="true"
        @editionChoose="edition">
      </pop-up-edition>
    </b-modal>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import AppBreadcrumb from '@/components/general/breadcrumb';
import { get } from '@/api/tiers';
import { getAllByTiers } from '@/api/contacts';
import messageErreur from '@/services/general/messageErreur';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import DetailFournisseurSupport from '@/components/achat/fournisseurSupport/detailFournisseurSupport/detailFournisseurSupport';
import ProduitFournisseurSupport from '@/components/achat/fournisseurSupport/detailFournisseurSupport/produitFournisseurSupport/index';
import { FOURNISSEUR_SUPPORT } from '@/configuration/presse/permissionsPresseConf';
import pieceJointeButton from '@/components/general/button/pieceJointeButton';
import dropdownButton from '@/components/general/button/dropdownButton';
import popupFusionTiers from '@/components/clients/clients/popupFusionTiers';
import {
  TIERS_TYPE_FOURNISSEUR,
  TIERS_SOUS_TYPE_FOURNISSEUR_SUPPORT,
  LISTE_CHOICE_EDITION_TIERS, TYPE_DONNEE_EXTRAIT_COMPTE_TIERS,
} from '@/configuration/tiers/tiersConf';
import popUpEdition from '@/components/factures/p_edition';
import edition from '@/api/edition';
import validationGeneral from '@/services/validation/validation';
import readErrorBlobRequest from '@/services/edition/readBlobRequest';

const Attachments = createNamespacedHelpers('attachments');
const permissions = createNamespacedHelpers('permissions');

export default {
  data() {
    return {
      fournisseurSupport: null,
      activeTab: 'detailFournisseurSupport',
      permsFournisseurSupport: FOURNISSEUR_SUPPORT,
      openPopUpFusionTiers: false,
      constantes: {
        TIERS_TYPE_FOURNISSEUR,
        TIERS_SOUS_TYPE_FOURNISSEUR_SUPPORT,
      },
      popUpEdition: false,
      listeChoiceEdition: LISTE_CHOICE_EDITION_TIERS
        .filter(l => l.typeDonnee === TYPE_DONNEE_EXTRAIT_COMPTE_TIERS),
      errorEdition: {
        haveError: false,
        messages: [],
        champsVide: [],
        messagesChampsVide: [],
      },
    };
  },
  components: {
    AppBreadcrumb,
    routerLinkBlank,
    DetailFournisseurSupport,
    ProduitFournisseurSupport,
    pieceJointeButton,
    dropdownButton,
    popupFusionTiers,
    popUpEdition,
  },
  computed: {
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    breadcrumb() {
      return [
        { title: this.$i18n.t('detailFournisseurSupport.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('detailFournisseurSupport.breadcrumb.liste'), route: { name: 'l.presse.fournisseur_support' }, isActive: false },
        { title: this.$i18n.t('detailFournisseurSupport.breadcrumb.detail'), route: { name: '' }, isActive: true },
      ];
    },
    tabs() {
      return ['detailFournisseurSupport', 'produitFournisseurSupport'];
    },
    actionSecondary() {
      const actions = [
        {
          label: this.$t('detailClient.popupFusionTiers.fournisseurSupport.title'),
          action: () => { this.openPopUpFusionTiers = true; },
        },
      ];
      return actions;
    },
  },
  methods: {
    ...Attachments.mapActions({
      setAttachmentContext: 'setContext',
      setAttachmentElementId: 'setElementId',
    }),
    ...permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    async edition(donnees) {
      const loadingComponent = this.$buefy.loading.open();
      this.errorEdition.champsVide = [];
      this.errorEdition.messagesChampsVide = [];
      this.errorEdition.messages = [];
      this.errorEdition.haveError = false;
      try {
        const response = await edition({
          ids: [this.fournisseurSupport.id],
          extension: donnees.format,
          typeDonnee: donnees.typeDonnee,
          typeEdition: donnees.typeEdition ? donnees.typeEdition : '',
          parametresAdditionnels: donnees.parametresAdditionnels,
        });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(response.data);
        const disposition = response.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
        loadingComponent.close();
        this.popUpEdition = false;
      } catch (e) {
        const errorResponseString = await readErrorBlobRequest(e.response.data);
        const response = JSON.parse(errorResponseString);
        validationGeneral(this.$i18n, { data: response }, this.errorEdition.champsVide,
          this.errorEdition.messages, this.errorEdition.messagesChampsVide);
        this.errorEdition.haveError = true;
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.setAttachmentContext({ module: 'Client' });
      const fournisseurSupport = (await get(this.$route.params.id)).data.result;
      fournisseurSupport.contacts = (await getAllByTiers(fournisseurSupport.id)).data.result.items;
      await this.setAttachmentElementId({ id: fournisseurSupport.id });
      this.fournisseurSupport = fournisseurSupport;
      this.setInformationPage(this.$t('pageGeneral.detail', { item: this.fournisseurSupport.nomCommercial }));
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      messageErreur(this.$i18n);
      throw e;
    }
  },
};
</script>
